import React, { useState } from "react";
import { ThemeIcon, NavLink } from "@mantine/core";
import { Link } from "react-router-dom";

type NavItemProps = {
  color: string;
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
  active?: boolean;
} & ({ to: string; href?: never } | { to?: never; href: string });

export const NavItem = (props: NavItemProps) => {
  const { color, icon, label, to, href, onClick, active } = props;
  const [hovered, setHovered] = useState(false);

  const commonProps = {
    onClick,
    onMouseEnter: () => {
      setHovered(true);
    },
    onMouseLeave: () => {
      setHovered(false);
    },
    label,
    active,
    leftSection: (
      <ThemeIcon color={color} variant={active ? "filled" : "light"}>
        {icon}
      </ThemeIcon>
    ),
    style: {
      transition: "transform 150ms ease, background-color 150ms ease",
      transform: hovered ? "translateX(4px)" : "none",
    },
  };

  if (href) {
    return (
      <NavLink
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        {...commonProps}
      />
    );
  }

  return <NavLink component={Link} to={to!} {...commonProps} />;
};
